import { createSlice } from '@reduxjs/toolkit';
import type { AddressResponse } from 'api/models/TAddress';

export type SelectedAddressState = {
  data: {
    selectedAddress: AddressResponse | null;
  };
};
export const initialState: SelectedAddressState = {
  data: {
    selectedAddress: null
  }
};

export const slice = createSlice({
  name: 'selectedAddress',
  initialState,
  reducers: {
    setSelectedAddress: (state, { payload }) => {
      state.data.selectedAddress = payload;
    },
    setInitialState: (state) => {
      state.data.selectedAddress = initialState.data.selectedAddress;
    }
  }
});

export const { setSelectedAddress, setInitialState } = slice.actions;
export const selectSlice = (state) => state[slice.name];
export const selectedAddress = (state) =>
  selectSlice(state).data.selectedAddress;

export default slice.reducer;
